import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import EmailForm from '../components/EmailForm';
import '../styles/Yhteistiedot.css';
import { useTranslations } from '../hooks/useTranslations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faTiktok, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const Yhteistiedot = () => {
  const [showLinks, setShowLinks] = useState(false);
  const { t } = useTranslations();

  return (
    <div className="yhteistiedot">
      <div className="yhteistiedot-video-backdrop">
        <video
          className="yhteistiedot-video"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          aria-label={t('contact.videoAriaLabel', 'Ota yhteyttä video')}
        >
          <source src="/Contact us video.mp4" type="video/mp4" />
          <source src="Contact us video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="yhteistiedot-video-overlay" />
      </div>
      <div className="yhteistiedot-inner">
        <Navbar showLinks={showLinks} setShowLinks={setShowLinks} />
        <div className='yhteistiedot-main'>
          <h1 className="yhteistiedot-heading">{t('contact.heading', 'Ota yhteyttä')}</h1>
          <div className="yhteistiedot-content-wrapper">
            <div className="email-form-container">
              <EmailForm />
            </div>
            <div className="company-info">
              <h2>{t('contact.company.name', 'Tuutorikeskus Oy')}</h2>
              <h3>{t('contact.company.emailHeading', 'Sähköposti')}</h3>
              <p>info.tuutorikeskus@gmail.com</p>
              <h3>{t('contact.company.phoneHeading', 'Puhelin')}</h3>
              <p>+358 442 447 576</p>
              <div className="social-media">
                <a
                  href="https://www.facebook.com/TuutoriKeskus"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t('hero.socials.facebook', 'TuutoriKeskus Facebookissa')}
                >
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a
                  href="https://www.instagram.com/tuutorikeskus/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t('hero.socials.instagram', 'TuutoriKeskus Instagramissa')}
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a
                  href="https://www.tiktok.com/@tuutorikeskus"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t('hero.socials.tiktok', 'TuutoriKeskus TikTokissa')}
                >
                  <FontAwesomeIcon icon={faTiktok} />
                </a>
                <a
                  href="https://wa.me/358442447576"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t('hero.socials.whatsapp', 'Ota yhteyttä WhatsAppissa')}
                >
                  <FontAwesomeIcon icon={faWhatsapp} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Yhteistiedot;
